import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Close from '@material-ui/icons/Close';
import ConditionForm from './ConditionForm';
import './ConditionModal.css';
const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.';

export default function ConditionModal({ setOpen, conditionInfo, variables, setOpenVariable, handleAdd, handleUpdate, handleDelete, onClose, process, variableRender }) {
    const { t } = useTranslation();

    const conditionBackup = useRef();

    const handleClose = () => {
        if (onClose) { onClose(conditionBackup.current); }
        else { setOpen(false); }
    };

    return (
        <Dialog open={true} onClose={handleClose}>
            <DialogTitle >
                <div className="modal-title">
                    {handleAdd ? t(label + 'MODAL.HEADER') : t(label + 'MODAL.UPDATE')}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent style={{ minWidth: 300 }}>

                <Condition conditionInfo={conditionInfo} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} process={process} conditionBackup={conditionBackup} />
            </DialogContent>
            <DialogActions className="modal-actions">
                {handleDelete &&
                    <Button
                        onClick={handleDelete}
                        variant="outlined"
                        style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                        {t('CONTENT.DATATABLE.SELECTEDROWS.DELETE')}
                    </Button>}
                <Button
                    onClick={handleAdd ? handleAdd : handleUpdate}
                    variant="outlined"
                    style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                    {handleAdd ? t('CONTENT.CONFIGURATION-FORM.ADD') : t('CONTENT.CONFIGURATION-FORM.UPDATE')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export function Condition({ conditionInfo, conditionBackup, variables, variableRender, process, setOpenVariable, setField }) {
    const { t } = useTranslation();
    const [condition, setCondition] = useState('');
    const [firstBoolValue, setFirstBoolValue] = useState('');
    const [secondBoolValue, setSecondBoolValue] = useState('');
    const [operator, setOperator] = useState('eq');

    useEffect(() => {
        if (conditionInfo.firstBool) {
            if (conditionInfo.condition === 'boolean') { setFirstBoolValue(conditionInfo.fields.firstValue.value); }
            else { setFirstBoolValue('true'); }
        }
        else { setFirstBoolValue('variable'); }
        if (conditionInfo.secondBool) {
            if (conditionInfo.condition === 'boolean') { setSecondBoolValue(conditionInfo.fields.secondValue.value); }
            else { setSecondBoolValue('true'); }
        }
        else { setSecondBoolValue('variable'); }
        if (conditionBackup) {
            conditionBackup.current = JSON.parse(JSON.stringify(conditionInfo));
        }
        setCondition(conditionInfo.condition);
        setOperator(conditionInfo.operator);
    }, []);

    const handleConditionChange = (e) => {
        let value = e.target.value;

        conditionInfo.condition = value;
        conditionInfo.fields.firstValue.value = '';
        conditionInfo.fields.secondValue.value = '';
        conditionInfo.fields.firstValue.htmlValue = '';
        conditionInfo.fields.secondValue.htmlValue = '';

        if (value === conditionBackup.current.condition) {
            conditionInfo.fields.firstValue.value = conditionBackup.current.fields.firstValue.value;
            conditionInfo.fields.secondValue.value = conditionBackup.current.fields.secondValue.value;
            conditionInfo.fields.firstValue.htmlValue = conditionBackup.current.fields.firstValue.htmlValue;
            conditionInfo.fields.secondValue.htmlValue = conditionBackup.current.fields.secondValue.htmlValue;
        }
        setCondition(value);
        if (setField) {
            setField('condition', value)
        }
        if (conditionInfo.condition === 'boolean') {
            setFirstBoolValue('');
            setSecondBoolValue('');
        }
        else {
            setFirstBoolValue('true');
            setSecondBoolValue('true');
        }
        if (conditionInfo.condition === 'object') {
            conditionInfo.operator = 'hop';
            setOperator('hop');
        }
    };

    const handleOperatorChange = (e) => {
        let value = e.target.value;
        conditionInfo.operator = value;
        if (setField) {
            setField('operator', value)
        }
        if (value === 'empty' || value === 'nempty') {
            conditionInfo.fields.secondValue.value = '';
        }
        setOperator(value);
    };

    const handleFirstBoolChange = (e) => {
        let value = e.target.value;
        if (value === 'variable') {
            if (conditionInfo.firstBool) {
                conditionInfo.fields.firstValue.value = '';
                conditionInfo.fields.firstValue.htmlValue = '';
            }
            conditionInfo.firstBool = false;
        }
        else {
            conditionInfo.firstBool = true;
            if (conditionInfo.condition === 'boolean') {
                conditionInfo.fields.firstValue.value = value;
                conditionInfo.fields.firstValue.htmlValue = '';
            }
        }
        setFirstBoolValue(value);
    };

    const handleSecondBoolChange = (e) => {
        let value = e.target.value;
        if (value === 'variable') {
            if (conditionInfo.secondBool) {
                conditionInfo.fields.secondValue.value = '';
                conditionInfo.fields.secondValue.htmlValue = '';
            }
            conditionInfo.secondBool = false;
        }
        else {
            conditionInfo.secondBool = true;
            if (conditionInfo.condition === 'boolean') {
                conditionInfo.fields.secondValue.value = value;
                conditionInfo.fields.secondValue.htmlValue = '';
            }
        }
        setSecondBoolValue(value);
    };

    const filterOperators = () => {
        return !(condition === 'boolean' || condition === 'string' || condition === 'array' || condition === 'object');

    };

    return (
        <div>

            <div>
                <span className="dialog-text-medium">{t(label + 'MODAL.CHOOSE')}</span>
                <Select value={condition} onChange={handleConditionChange} variant="outlined" fullWidth>
                    <MenuItem value="boolean">Boolean</MenuItem>
                    <MenuItem value="string">String</MenuItem>
                    <MenuItem value="number">Number</MenuItem>
                    <MenuItem value="date">Date</MenuItem>
                    {!process && <MenuItem value="object">Object</MenuItem>}
                    {!process && <MenuItem value="array">Array</MenuItem>}
                    {!process && <MenuItem value="datatable">Data Table</MenuItem>}
                    {!process && <MenuItem value="ping">Ping</MenuItem>}
                    {!process && <MenuItem value="dictionary">Dictionary</MenuItem>}
                    {!process && <MenuItem value="length">Length</MenuItem>}
                </Select>
            </div>

            {
                condition !== '' && <div>
                    <ConditionForm condition={condition} conditionInfo={conditionInfo}
                        variables={variables} setOpenVariable={setOpenVariable}
                        inputName="firstValue" boolValue={firstBoolValue}
                        onTypeChange={handleFirstBoolChange}
                        variableRender={variableRender} setField={setField} />
                    {(condition !== 'ping' && condition !== 'dictionary') &&
                        <div><span className="dialog-text-medium">Operator: </span>&nbsp;<Select value={operator} onChange={handleOperatorChange} variant="outlined">
                            {filterOperators() && <MenuItem value="gt">&gt; ({t(label + 'GT')})</MenuItem>}
                            {filterOperators() && <MenuItem value="ge">&ge; ({t(label + 'GE')})</MenuItem>}
                            {condition !== 'object' && <MenuItem value="eq">= ({t(label + 'EQ')})</MenuItem>}
                            {condition !== 'object' && <MenuItem value="ne">&ne; ({t(label + 'NE')})</MenuItem>}
                            {condition !== 'object' && condition !== 'number' && <MenuItem value="empty">&empty; ({t(label + 'EMPTY')}) </MenuItem>}
                            {condition !== 'object' && condition !== 'number' && <MenuItem value="nempty">{t(label + 'NEMPTY')}</MenuItem>}
                            {condition === 'object' && <MenuItem value="hop">{t(label + 'HOP')}</MenuItem>}
                            {(condition === 'array' || condition === 'string') && <MenuItem value="contains">{t(label + 'CONTAINS')}</MenuItem>}
                            {filterOperators() && <MenuItem value="lt">&lt; ({t(label + 'LT')})</MenuItem>}
                            {filterOperators() && <MenuItem value="le">&le; ({t(label + 'LE')})</MenuItem>}
                        </Select></div>
                    }
                    {(condition !== 'ping' && operator !== 'empty' && operator !== 'nempty') &&
                        <ConditionForm condition={condition} conditionInfo={conditionInfo}
                            variables={variables} setOpenVariable={setOpenVariable}
                            inputName="secondValue" boolValue={secondBoolValue}
                            onTypeChange={handleSecondBoolChange}
                            variableRender={variableRender} setField={setField} />
                    }
                </div>
            }
        </div>
    )
}
